import React from "react";

import {Icon, Grid} from "semantic-ui-react";

import "./ToastNotification.css";


const ToastNotification = (props) => (
        <Grid>
            <Grid.Row>
                <Grid.Column width={2} verticalAlign="middle">
                    <Icon name={props.iconName} size="big"/>
                </Grid.Column>
                <Grid.Column width={13} textAlign="justified">
                    {props.message}
                </Grid.Column>
            </Grid.Row>
        </Grid>
)

export default ToastNotification;


// WEBPACK FOOTER //
// ./src/components/ToastNotification/ToastNotification.js